import * as React from 'react';
import HealthPlanUserInformationForm from './HealthPlanUserInformationForm';
import { useEffect, useState } from 'react';
import { useLazyHealthPlanUserInformationQuery } from '../../../graphql/graphql';
import apiClient from '../../../Services/ApiClient';
import { useTreatmentContext } from '../../../Services/TreatmentContext';
// @ts-ignore
import styles from './HealthPlanUserInformation.module.scss';
import ScrollContainer from '../../Base/Components/ScrollContainer';

interface HealthPlanUserInformationProps {
	patientId: string;
	onSuccess?: () => void;
	setIsLoading: (isLoading: boolean) => void;
	wizardKey?: string;
}

const HealthPlanUserInformation: React.FC<
	HealthPlanUserInformationProps
> = props => {
	const { patientId: userId, onSuccess, setIsLoading, wizardKey } = props;
	const [getHealthPlanUserInformation] =
		useLazyHealthPlanUserInformationQuery();
	// @ts-ignore
	const { handleUserUpdated } = useTreatmentContext();

	useEffect(() => {
		if (!userId) {
			return;
		}

		loadData(userId);
	}, [userId]);

	const loadData = async (userId: string) => {
		await getHealthPlanUserInformation({
			userId,
		}).unwrap();
	};

	const handleSubmit = async (values: { [key: string]: any }) => {
		setIsLoading(true);
		values['meta'] = [
			{
				key: 'healthPlanUserInformationFilled',
				value: true,
			},
		];
		await apiClient.patch('/patients/' + userId, values);
		handleUserUpdated();
		setIsLoading(false);
		onSuccess?.();
	};

	return (
		<ScrollContainer>
			<div className={styles.wrapper}>
				<HealthPlanUserInformationForm
					onSubmit={handleSubmit}
					wizardKey={wizardKey}
					userId={userId}
				/>
			</div>
		</ScrollContainer>
	);
};

export default HealthPlanUserInformation;
